import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { _post } from '../../../utils/network';

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import FormField from "../../../components/Form/FormField/FormField.component";
import LoadingButton from '../../../components/LoadingButton/LoadingButton.component';
import ListTable from '../../../components/List/ListTable/ListTable.component';
import Pagination from '../../../components/List/Pagination/Pagination.component';

const StocksList = () => {
	const { t } = useTranslation();
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('stocks'), link: '/stocks-list' },
		{ title: t('list') }
	];

	const [stocks, setStocks] = useState([]);
	let stocksListData = {
		head: [t('title'), t('isin'), t('category'), t('description')],
		body: stocks.map(stock => [
			stock.stock_information.stock_symbol,
			stock.isin,
			stock.stockcategory_id_information.stockcategory_name,
			stock.stock_name
		]),
		directions: ['rtl', 'ltr', 'rtl']
	};

	const [pageNumber, setPageNumber] = useState(1);
	const [pageCounter] = useState(10);
	const [totalCount, setTotalCount] = useState(0);
	const [pagesCount, setPagesCount] = useState(0);
	const [searchStockTitle, setSearchStockTitle] = useState(null);
	const [searchStockISIN, setSearchStockISIN] = useState(null);
	const [searchButtonIsLoading, setSearchButtonIsLoading] = useState(false);
	const [searchCounter, setSearchCounter] = useState(0);
	const getStocks = async () => {
		let body = {
			stock_name: searchStockTitle,
			isin: searchStockISIN,
			stockcategory_id: null,
			page: pageNumber,
			count: pageCounter
		};
		setSearchButtonIsLoading(true);
		let response = await _post('/stocks/admin/getAll', body);
		setSearchButtonIsLoading(false);
		switch(response.code){
			case 200:
				setTotalCount(response.data.all_stocks);
				setStocks(response.data.stocks);
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};
	
	const filterStocks = event => {
		event.preventDefault();
		if(searchButtonIsLoading)
			return 0;
		let title = event.target.searchStockTitle.value.trim() || null;
		let isin = event.target.searchStockISIN.value.trim() || null;
		setSearchStockTitle(title);
		setSearchStockISIN(isin);
		if(pageNumber === 1)
			setSearchCounter(searchCounter + 1);
		else
			setPageNumber(1);
	};
	
	useEffect(() => {
		setPagesCount(Math.ceil(totalCount / pageCounter));
	}, [totalCount]);
	
	useEffect(() => {
		setSearchCounter(searchCounter + 1);
	}, [pageNumber]);

	useEffect(() => {
		getStocks();
	}, [searchCounter]);
	
	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<div className="card mb-3">
				<div className="card-header">
					<h5 className="mb-0">{t('search_for')} {t('stocks')}</h5>
				</div>
				<div className="card-body bg-light">
					<form onSubmit={filterStocks}>
						<div className="row gx-2">
							<FormField fieldKey="searchStockTitle" title={t('title')} value={searchStockTitle} isSearch={true} />
							<FormField fieldKey="searchStockISIN" title={t('isin')} value={searchStockISIN} isSearch={true} />
						</div>
						<div>
							<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="create" isLoading={searchButtonIsLoading}>
								<i className="fa fa-search"></i> {t('search')}
							</LoadingButton>
						</div>
					</form>
				</div>
			</div>
			<ListTable title={t('stocks')} pageNumber={pageNumber} pageCounter={pageCounter} totalCount={totalCount} data={stocksListData} />
			<Pagination pagesCount={pagesCount} action={setPageNumber} />
		</>
	);
};

export default StocksList;
